<template>
  <header class="header">
    <div class="header-left">
      <div class="logo" @click="$router.push('/')">
        <!-- <img src="../assets/logowhite.png" alt="Logo"> -->
        <!-- <span class="logo-text">结行车加</span> -->
      </div>
      <nav class="nav">
        <li><router-link to="/" exact>首页</router-link></li>
        <li class="product" @mouseenter="showDropdown" @mouseleave="hideDropdown">
          <router-link to="/product">产品</router-link>
          <ul class="dropdown" :class="{ 'show': isDropdownVisible }">
            <li 
              @click="$router.push('/product/businessManage')"
              :class="{ 'active': $route.path === '/product/businessManage'|| $route.path === '/product'}"
            >业务管理</li>
            <li 
              @click="$router.push('/product/financeManage')"
              :class="{ 'active': $route.path === '/product/financeManage' }"
            >财务管理</li>
            <li 
              @click="$router.push('/product/manageDecision')"
              :class="{ 'active': $route.path === '/product/manageDecision' }"
            >决策管理</li>
          </ul>
        </li>
        <li><router-link to="/case" :class="{ 'router-link-active': $route.path === '/caseItem'}">案例</router-link></li>
        <li><router-link to="/service">服务</router-link></li>
        <li><router-link to="/news">资讯</router-link></li>
        <li><router-link to="/about">关于</router-link></li>
      </nav>
    </div>
    <div class="auth-buttons">
      <!-- <button class="register">注册</button>
      <button class="login">登录</button> -->
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      isDropdownVisible: false
    };
  },
  methods: {
    showDropdown() {
      this.isDropdownVisible = true;
    },
    hideDropdown() {
      this.isDropdownVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 120px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .header-left {
    display: flex;
    align-items: center;
    gap: 30px;
    font-weight: 400;
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 113.57px;
    height: 30px;
    background-image: url('@/assets/logowhite.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .nav {
    display: flex;
    gap: 40px;
    position: relative;

    li {
      list-style: none;
      font-weight: 400;
    }

    a {
      text-decoration: none;
      color: rgba(255, 255, 255, 1);
      
      padding-bottom: 5px;

      &.router-link-active {
        background-image: url('@/assets/linewhite.png');
        background-repeat: no-repeat;
        background-size: 50% 1.5px;
        background-position: 50% bottom;
      }
    }
  }

  .dropdown {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    // 修改初始状态，将菜单向上移动自身高度 
    opacity: 0;
    visibility: hidden;
    // 增加 transform 过渡
    transition: opacity 1s ease-out, visibility 1s ease-out;
    position: absolute;
    background-color: #FFFFFF;
    padding: 10px;
    height: 157px;
    width: 130px;
    border-radius: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-weight: 400;
    top: 46px;
    left: 20px;

    li {
      background-color: #f8f9fb;
      color: #272D41;
      line-height: 35px;
      text-align: center;
      border-radius: 50px;
      &:hover {
        color: rgba(0, 46, 166, 1) !important;
        background-color: #E6EEFC !important;
      }

      cursor: pointer;
    }
  }

  .active {
    color: rgba(0, 46, 166, 1) !important;
    background-color: #E6EEFC !important;
  }

  // 添加 show 类控制显示和动画
  .dropdown.show {
    // 恢复菜单位置 
    opacity: 1;
    visibility: visible;

  }

  .auth-buttons {
    display: flex;
    gap: 15px;

    button {
      padding: 8px 20px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;

      &.register {
        background: white;
        border: none;
        color: #1A237E;
        border-radius: 20px;
      }
      &.login {
        background: #1A237E;
        border: none;
        color: white;
        border-radius: 20px;
      }
    }
  }
}
</style>